import { Component, Inject, PLATFORM_ID } from '@angular/core';
import * as firebase from 'firebase/app';
import 'firebase/messaging';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { environment } from 'src/environments/environment';
import {SwPush } from '@angular/service-worker';
import { isPlatformBrowser} from '@angular/common';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  displayToken: string;
  isBrowser: boolean;
  constructor(push: SwPush, private afm: AngularFireMessaging, @Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId)
    push.messages.subscribe(msg => console.log('push message', msg));
    push.notificationClicks.subscribe(click => console.log('notification click', click));
    if (this.isBrowser) {
      console.log("is browser");
      // navigator.serviceWorker.getRegistration().then(swr => this.afm.useServiceWorker(swr));
      if (!firebase.apps.length) {
        firebase.initializeApp(environment.firebaseConfigSecondary);
        navigator.serviceWorker.getRegistration().then(swr => firebase.messaging().useServiceWorker(swr));
      }
    }
    /*if (!firebase.apps.length) {
      firebase.initializeApp(environment.firebaseConfigSecondary);
      navigator.serviceWorker.getRegistration().then(swr => firebase.messaging().useServiceWorker(swr));
    }*/
  }

  /*permitToNotify() {
    const messaging = firebase.messaging();
    messaging.requestPermission()
      .then(() => messaging.getToken().then(token => this.displayToken = token))
      .catch(err => {
        console.log('Unable to get permission to notify.', err);
      });
  }*/

  ngOnInit() {
    /*this.afm.requestToken.subscribe(
      (token) => {
          console.log('Permission granted! Save to the server!', token);
      });*/
    //this.msg.requestPermission();
    //this.msg.receiveMessage();
    if (this.isBrowser) {
      const messaging = firebase.messaging();
      messaging.requestPermission()
        .then(() => messaging.getToken().then(token => {
          this.displayToken = token
          console.log(this.displayToken)
        }))
        .catch(err => {
          console.log('Unable to get permission to notify.', err);
        });
      }
  }
}
